module.exports = __webpack_public_path__ + "img/subhealthy.81516df0.png";